/* global currentUser:true PubSub:true */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bowserFlags } from 'lib/bowser'
import cx from 'classnames'

import * as blUrls from 'lib/urls'
import Tappable from 'react-tappable'

import { SHOW_APP_MODAL_EVENT, SHOW_MOBILE_NAV_EVENT } from 'shared/constants'
import * as css from './mobile-tab-bar.scss'

class MobileTabBar extends Component {
  constructor(props) {
    super(props)
    const { isVisible, currentUser } = props
    this.state = {
      isVisible: isVisible || false,
      currentUser: currentUser || null,
    }
  }

  componentDidMount() {
    PubSub.subscribe(SHOW_MOBILE_NAV_EVENT, (event) => {
      if (bowserFlags.mobile) {
        this.setState({ isVisible: true })
      }
    })

    //bootstrap
    setTimeout(() => {
      PubSub.publish(SHOW_MOBILE_NAV_EVENT)
    }, 1)
  }

  render() {
    const { isVisible, currentUser } = this.state
    if (!isVisible) {
      return null
    }
    const {
      isHomePage,
      isAddItemsPage,
      isRegistryPage,
      mobileAddItemsExperimentIsActive,
      isHelloBabyPage,
      isStorePage,
    } = this.props
    const homeUrl = currentUser ? blUrls.registryHomePath : blUrls.indexPath
    const registryUrl = currentUser
      ? blUrls.registryPath(currentUser.registryUrlSlug)
      : blUrls.whyBabyListPath

    return (
      <div className={css.affixMobileNav}>
        <div className={css.mobileMenuContainer}>
          <Tappable
            className={cx({ [css.active]: isHomePage })}
            component="a"
            href={homeUrl}
          >
            <div className={cx(css.iconMobileNav, css.iconHome)} />
            <span className={css.iconText}>Home</span>
          </Tappable>
          <Tappable
            className={cx({ [css.active]: isRegistryPage })}
            component="a"
            href={registryUrl}
          >
            <div className={cx(css.iconMobileNav, css.iconRegistry)} />
            <span className={css.iconText}>Registry</span>
          </Tappable>
          {mobileAddItemsExperimentIsActive ? (
            <Tappable
              className={cx({ [css.active]: isAddItemsPage })}
              component="a"
              href={blUrls.registryAddItemsPath}
            >
              <div className={cx(css.iconMobileNav, css.iconAnyStore)} />
              <span className={css.iconText}>Add Items</span>
            </Tappable>
          ) : (
            <Tappable
              component="a"
              href={'javascript:void(0)'}
              onClick={() => PubSub.publish(SHOW_APP_MODAL_EVENT)}
            >
              <div className={cx(css.iconMobileNav, css.iconAnyStore)} />
              <span className={css.iconText}>Add Items</span>
            </Tappable>
          )}
          <Tappable
            className={cx({ [css.active]: isHelloBabyPage })}
            component="a"
            href={blUrls.helloBabyPath}
          >
            <div className={cx(css.iconMobileNav, css.iconGuides)} />
            <span className={css.iconText}>Guides</span>
          </Tappable>
          <Tappable
            className={cx({ [css.active]: isStorePage })}
            component="a"
            href={blUrls.catalogPath}
          >
            <div className={cx(css.iconMobileNav, css.iconStore)} />
            <span className={css.iconText}>Shop</span>
          </Tappable>
        </div>
      </div>
    )
  }
}

MobileTabBar.propTypes = {
  isRegistryPage: PropTypes.bool,
  isAddItemsPage: PropTypes.bool,
  isHelloBabyPage: PropTypes.bool,
  isHomePage: PropTypes.bool,
  isStorePage: PropTypes.bool,
  mobileAddItemsExperimentIsActive: PropTypes.bool,
  isVisible: PropTypes.bool,
  currentUser: PropTypes.shape({}),
}

export default MobileTabBar
